import React, {Component} from 'react';
import Dotdotdot from 'react-dotdotdot';
import { DEFAULT_LANGUAGE } from '../../../service/constants';
import { getLanguageBadge } from '../../../utils/language.utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

class ProcedureItemComponent extends Component {
    constructor(props){
        super(props);

    }

    getUrlForLang = (lang) => {
        const base = `/procedimiento/${this.props.procedure.id}`;
        return lang !== DEFAULT_LANGUAGE ? `${base}?lang=${lang}` : base;
    };

    render(){
        const procedure = this.props.procedure;
        const availableLanguages = this.props.availableLanguages || [DEFAULT_LANGUAGE];
        const displayLanguage = this.props.displayLanguage || DEFAULT_LANGUAGE;
        
        const url = this.getUrlForLang(displayLanguage);
        
        const stylePreview = {backgroundImage:`url(${procedure.preview})`};
        const type = (this.props.userType=== "Premium"|| this.props.userType === "Legacy") ?"": procedure.type === "Gratis"? "free":"premium";
        const videoType = `video ${type}`;
        
        return(
            <div className="col-lg-4 col-md-6 video-container d-flex">
                <div className={"flex-fill " + videoType} >
                    <div 
                        role="link"
                        tabIndex={0}
                        onClick={() => { window.location.href = url; }}
                        onKeyDown={(e) => { if (e.key === 'Enter') window.location.href = url; }}
                        style={{ height: '100%', display: 'flex', flexDirection: 'column', cursor: 'pointer' }}
                    >
                        <div className="video-thumb" style={stylePreview}>
                        </div>
                        <div className="video-content flex-grow-1" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <div>
                                <h3>
                                    {procedure.name}
                                </h3>
                                <p className="procedure_detail">
                                    <Dotdotdot clamp={3}>
                                        {procedure.detail}
                                    </Dotdotdot>
                                </p>
                            </div>
                            {availableLanguages.length > 0 && (
                                <div className="language-badges" onClick={(e) => e.stopPropagation()}>
                                    <span className="mr-1 text-black"><FontAwesomeIcon icon={faGlobe} /></span>
                                    {availableLanguages.map(lang => (
                                        <a
                                            key={lang}
                                            href={this.getUrlForLang(lang)}
                                            className="language-badge badge badge-light mr-1"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            {getLanguageBadge(lang)}
                                        </a>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ProcedureItemComponent;